import { Check, X } from "lucide-react";
import { useSectionView } from "@/hooks/use-section-view";

const differentials = [
  {
    title: "Multi Gestão Integrada vs. Ferramentas Fragmentadas",
    aroan: "Plataforma unificada desde o início - cada funcionalidade trabalha em conjunto de forma nativa",
    others: "Múltiplas ferramentas desconectadas - funcionalidades isoladas que não se comunicam",
  },
  {
    title: "Unificação Real vs. Integração Superficial",
    aroan: "Plataforma única que elimina fragmentação - dados, fluxos e canais nativamente unificados",
    others: "Múltiplas ferramentas 'integradas' via API - dados fragmentados, sincronia imperfeita",
  },
  {
    title: "Contextos Específicos vs. Respostas Genéricas",
    aroan: "VIA aprende seu negócio - respostas precisas baseadas em seus dados, processos e histórico",
    others: "Assistentes genéricos - respostas baseadas em conhecimento geral da internet",
  },
];

const DifferentialsSection = () => {
  const sectionRef = useSectionView<HTMLElement>("differentials");
  return (
    <section ref={sectionRef} className="py-20 lg:py-32 bg-gradient-to-br from-primary/5 to-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            Três Diferenciais Que{" "}
            <span className="text-primary">Nenhum Concorrente Oferece</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Não acredite apenas na nossa palavra - compare você mesmo
          </p>
        </div>

        <div className="space-y-8 max-w-5xl mx-auto">
          {differentials.map((diff, index) => (
            <div
              key={index}
              className="bg-card rounded-2xl border border-border overflow-hidden animate-scale-in"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="bg-accent/50 px-6 py-4 border-b border-border">
                <h3 className="text-xl font-semibold">{diff.title}</h3>
              </div>
              <div className="grid md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-border">
                <div className="p-6 space-y-3">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-success/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check className="w-4 h-4 text-success" />
                    </div>
                    <div>
                      <p className="font-semibold text-success mb-2">AROAN</p>
                      <p className="text-foreground leading-relaxed">{diff.aroan}</p>
                    </div>
                  </div>
                </div>
                <div className="p-6 space-y-3 bg-muted/30">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-urgency/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <X className="w-4 h-4 text-urgency" />
                    </div>
                    <div>
                      <p className="font-semibold text-muted-foreground mb-2">Concorrentes</p>
                      <p className="text-muted-foreground leading-relaxed">{diff.others}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DifferentialsSection;
